module.exports = __webpack_public_path__ + "static/media/fb.4dac923e.svg";